import { fromJS } from 'immutable';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';

// init data
const defaultState = fromJS({
    infoList: {
        username: "--",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        office: "",
        hire_date: "",
        salary: "",
    },
});

// action key
const GET_INFO = 'home/GET_INFO';
const SET_INFO = 'home/SET_INFO';
// action
export const setInfoList = (value) => ({ type: SET_INFO,value });

export const getInfo = () => {
    return (dispath) => {
        //异步action
        instance.get(BASE_URL + 'users/current').then((res) => {
            let data = res.data.data
            for (const key in data) {
                if (data[key] == null) {
                    data[key] = "";
                }
            }
            const value = fromJS(data)
            console.log(data);
            dispath({ type: GET_INFO, value })
        }).catch((err) => {
            return err
        });
    }
};
export const saveInfo = (params, callback) => {
    return (dispath) => {
        //异步action
        instance.put(BASE_URL + 'users/current',params).then((res) => {
            if(res.status === 200){
                callback(true);
            }else{
                callback(false);
            }
        }).catch((err) => {
            callback(false);
            return err
        });
    }
};

// reducer
export const reducer = (state = defaultState, action) => {
    if (action.type === SET_INFO) {
        return state.set('infoList',action.value);
    }else if (action.type === GET_INFO) {
        return state.set('infoList', action.value);
    }
    return state;
}